import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";

import {
  MantenimientoModulosReq,
  MantenimientoModulosRes,
} from "src/app/shared/model/mantenimiento-modulos/mantenimiento-modulos.model";
import { UrlConstantes } from "src/app/utilerias/constantes/urlconstantes";

/** Las llamadas de Mantenimiento de módulos (16/10/2026). */
@Injectable({ providedIn: "root" })
export class MantenimientoModulosService {
  private readonly http = inject(HttpClient);

  /** Lo que está en mantenimiento ahora. */
  activos(): Observable<MantenimientoModulosRes> {
    return this.http.post<MantenimientoModulosRes>(UrlConstantes.MANTENIMIENTO_MODULOS_ACTIVOS, {});
  }

  /** Lo que se puede poner en mantenimiento, lo que está y la bitácora. */
  catalogo(): Observable<MantenimientoModulosRes> {
    return this.http.post<MantenimientoModulosRes>(UrlConstantes.MANTENIMIENTO_MODULOS_CATALOGO, {});
  }

  /** Poner en mantenimiento, o cambiar el aviso y la fecha de regreso. */
  guardar(req: MantenimientoModulosReq): Observable<MantenimientoModulosRes> {
    return this.http.post<MantenimientoModulosRes>(UrlConstantes.MANTENIMIENTO_MODULOS_GUARDAR, req);
  }

  /** Terminar el mantenimiento. */
  terminar(clave: string): Observable<MantenimientoModulosRes> {
    return this.http.post<MantenimientoModulosRes>(UrlConstantes.MANTENIMIENTO_MODULOS_TERMINAR, { clave });
  }
}
